import { client } from "@/utils/client";

export function login(username, password) {
    const data = {
        username,
        password
    }
    return client({
        url: "/user/login",
        method: "post",
        data
    })
}

export function authen(email, password, query) {
    const data = {
        email,
        password
    }
    return client({
        url: "/user/authentication" + "?" + query,
        method: "post",
        data
    })
}

export function resetPwd(email, query) {
    const data = {
        email
    }
    return client({
        url: "/user/resetpassword?" + query,
        method: "post",
        data
    })
}

export function validateCaptcha(query) {
    return client({
        url: "/captcha?" + query,
        method: "post",
    })
}

export function logout() {
    return client({
        url: "/user/logout/",
        method: "post",
    })
}

export function getUserInfo() {
    return client({
        url: "/user/info/",
        method: "get"
    })
}


export function updateUserInfo() {
    return client({
        url: "/user/info/",
        method: "post"
    })
}

export function getAllUsers() {
    return client({
        url: "/users/",
        method: "get"
    })
}


//////////////////
// WEBPACK FOOTER
// ./src/api/user.js
// module id = null
// module chunks = 